<script setup>
import { useBreakpoints } from '@vueuse/core';
import { watch, computed, ref } from 'vue';

const props = defineProps({
    enabled: { type: Boolean, default: true },
    items: { type: Number },
    initialVisibleRows: { type: Number, default: 2 },
    step: { type: [Number,Object], default: () => ({ default: 4, sm: 6, lg: 8, })},
    breakpoints: { type: Object, default: () => ({ default: 0, sm: 680, lg: 1024, }) },
    itemsPerRow: { type: Object, default: () => ({ default: 2, sm: 3, lg: 4 })}
})
const bps = useBreakpoints(props.breakpoints)
const activeBreakpoint = bps.active()

const _step = computed(() => props.step[activeBreakpoint.value])
const rowItemCount = computed(() => props.itemsPerRow[activeBreakpoint.value])

const revealedIndex = ref(rowItemCount.value * props.initialVisibleRows - 1)

const revealed = computed(() => Math.min(revealedIndex.value + 1, props.items))

function isVisible(index) {
    if (!props.enabled) { return true }
    return index <= revealedIndex.value;
}

function canShowMore() {
    if (!props.enabled) { return false }
    return revealedIndex.value < props.items - 1;
}

function showMore() {
    if (!canShowMore()) { return; }
    revealedIndex.value = Math.min(revealedIndex.value + _step.value, props.items - 1)
}
</script>

<template>
    <slot
        v-bind="{ isVisible, canShowMore, showMore, enabled: props.enabled, revealed, items: props.items }"
        name="default"
    />
</template>

<style lang="scss">
@use "@/scss/framework" as *;

@layer components.show-more {

}
</style>
